import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../store'
import { SnackbarActions } from '../../store/snackbar'

interface ShowSnackbarOptions {
  variant?: 'success' | 'error'
  autoHideDuration?: number
  anchorOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'center' | 'right'
  }
}

export const useSnackbar = () => {
  const dispatch = useDispatch<AppDispatch>()

  const showSuccess = (message: string, options?: Omit<ShowSnackbarOptions, 'variant'>) => {
    dispatch(
      SnackbarActions.showSnackbar({
        message,
        options: {
          variant: 'success',
          autoHideDuration: 6000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          ...options,
        },
      }),
    )
  }

  const showError = (message: string, options?: Omit<ShowSnackbarOptions, 'variant'>) => {
    dispatch(
      SnackbarActions.showSnackbar({
        message,
        options: {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          ...options,
        },
      }),
    )
  }

  return {
    showSuccess,
    showError,
  }
}
